import moment from 'moment';
import { v4 as uuid } from 'uuid';
import channelIcon from '../../assets/images/channels/slo1.png';
import grinch from '../../assets/images/shows/grinch.png';

const epgData = [
  {
    id: 'slo1',
    name: 'SLO 1',
    logo: channelIcon,
    packagetags: ['A1 Kombo S', 'A1 Kombo M', 'A1 Kombo L'],
    schedule: [
      {
        date: moment().subtract(3, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '-3 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '-3 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '-3 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '-3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '-3 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '-3 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().subtract(2, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: 'Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: 'Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: 'Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().subtract(1, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 705, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 715,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 725,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 730,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 740,
            tags: ['info', 'HD'],
            title: 'Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 755,
            tags: ['info'],
            title: 'Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 810,
            tags: [],
            title: 'Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 850,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 905, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 915,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 925,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 930,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 940,
            tags: ['info', 'HD'],
            title: 'Šport',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 955,
            tags: ['info'],
            title: 'Vreme',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            title: 'Grinch',
            airTime: 1110,
            tags: ['movies', 'HD'],
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
            details: {
              tags: ['Informativni program'],
              image: grinch,
            },
          },
        ],
      },
      {
        date: moment().add(1, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+1 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+1 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+1 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+1 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+1 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+1 Vreme',
            details: {
              tags: ['informativni'],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+1 Intervju: Dejan Valentinčič',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+1 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(2, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+2 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+2 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+2 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+2 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+2 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+2 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+2 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+2 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(3, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+3 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+3 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+3 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+3 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+3 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(4, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+4 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+4 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+4 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+4 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+4 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+4 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+4 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+4 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(5, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+5 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+5 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+5 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+5 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+5 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+5 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+5 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+5 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(6, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+6 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+6 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+6 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+6 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+6 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+6 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+6 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+6 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(7, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+7 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+7 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+7 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+7 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+7 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+7 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+7 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+7 Duhovni utrip: Vrata upanja',
          },
        ],
      },
    ],
  },
  {
    id: 'slo2',
    name: 'SLO 2',
    logo: channelIcon,
    packagetags: ['A1 Kombo S'],
    schedule: [
      {
        date: moment().subtract(3, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '-3 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '-3 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '-3 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '-3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '-3 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '-3 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().subtract(2, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: 'Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: 'Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: 'Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().subtract(1, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 705, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 715,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 725,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 730,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 740,
            tags: ['info', 'HD'],
            title: 'Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 755,
            tags: ['info'],
            title: 'Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 810,
            tags: [],
            title: 'Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 850,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 905, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 915,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 925,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 930,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 940,
            tags: ['info', 'HD'],
            title: 'Šport',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 955,
            tags: ['info'],
            title: 'Vreme',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            title: 'Grinch',
            airTime: 1110,
            tags: ['movies', 'HD'],
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
            details: {
              tags: ['Informativni program'],
              image: grinch,
            },
          },
        ],
      },
      {
        date: moment().add(1, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+1 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+1 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+1 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+1 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+1 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+1 Vreme',
            details: {
              tags: ['informativni'],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+1 Intervju: Dejan Valentinčič',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+1 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(2, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+2 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+2 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+2 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+2 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+2 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+2 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+2 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+2 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(3, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+3 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+3 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+3 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+3 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+3 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(4, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+4 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+4 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+4 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+4 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+4 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+4 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+4 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+4 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(5, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+5 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+5 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+5 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+5 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+5 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+5 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+5 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+5 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(6, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+6 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+6 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+6 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+6 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+6 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+6 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+6 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+6 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(7, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+7 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+7 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+7 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+7 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+7 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+7 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+7 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+7 Duhovni utrip: Vrata upanja',
          },
        ],
      },
    ],
  },
  {
    id: 'slo3',
    name: 'SLO 3',
    logo: channelIcon,
    packagetags: ['A1 Kombo M'],
    schedule: [
      {
        date: moment().subtract(3, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '-3 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '-3 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '-3 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '-3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '-3 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '-3 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().subtract(2, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: 'Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: 'Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: 'Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().subtract(1, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 705, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 715,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 725,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 730,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 740,
            tags: ['info', 'HD'],
            title: 'Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 755,
            tags: ['info'],
            title: 'Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 810,
            tags: [],
            title: 'Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 850,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 905, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 915,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 925,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 930,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 940,
            tags: ['info', 'HD'],
            title: 'Šport',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 955,
            tags: ['info'],
            title: 'Vreme',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            title: 'Grinch',
            airTime: 1110,
            tags: ['movies', 'HD'],
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
            details: {
              tags: ['Informativni program'],
              image: grinch,
            },
          },
        ],
      },
      {
        date: moment().add(1, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+1 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+1 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+1 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+1 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+1 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+1 Vreme',
            details: {
              tags: ['informativni'],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+1 Intervju: Dejan Valentinčič',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+1 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(2, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+2 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+2 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+2 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+2 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+2 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+2 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+2 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+2 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(3, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+3 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+3 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+3 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+3 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+3 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(4, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+4 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+4 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+4 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+4 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+4 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+4 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+4 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+4 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(5, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+5 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+5 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+5 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+5 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+5 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+5 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+5 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+5 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(6, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+6 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+6 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+6 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+6 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+6 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+6 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+6 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+6 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(7, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+7 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+7 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+7 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+7 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+7 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+7 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+7 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+7 Duhovni utrip: Vrata upanja',
          },
        ],
      },
    ],
  },
  {
    id: 'slo4',
    name: 'SLO 4',
    logo: channelIcon,
    packagetags: ['A1 Kombo L'],
    schedule: [
      {
        date: moment().subtract(3, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '-3 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '-3 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '-3 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '-3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '-3 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '-3 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().subtract(2, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: 'Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: 'Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: 'Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().subtract(1, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 705, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 715,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 725,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 730,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 740,
            tags: ['info', 'HD'],
            title: 'Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 755,
            tags: ['info'],
            title: 'Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 810,
            tags: [],
            title: 'Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 850,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 905, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: 'Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 915,
            tags: ['info', 'najbolj gledani'],
            title: 'Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 925,
            tags: ['movies', 'HD'],
            title: 'Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 930,
            tags: ['info', 'HD'],
            title: 'Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 940,
            tags: ['info', 'HD'],
            title: 'Šport',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 955,
            tags: ['info'],
            title: 'Vreme',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            title: 'Grinch',
            airTime: 1110,
            tags: ['movies', 'HD'],
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: 'Duhovni utrip: Vrata upanja',
            details: {
              tags: ['Informativni program'],
              image: grinch,
            },
          },
        ],
      },
      {
        date: moment().add(1, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+1 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+1 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+1 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+1 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+1 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+1 Vreme',
            details: {
              tags: ['informativni'],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+1 Intervju: Dejan Valentinčič',
            details: {
              originalTitle: 'How the Grinch Stole Christmas',
              tags: ['Film', ['Družinski', 'Fantazijski'], '104 minute', '2000', 'ZDA'],
              scores: [7.2, 7.5],
              image: grinch,
              description:
                'Visoko na gori nad mestom čudaški samotar Grinch opazuje ljudi, ki živijo v pričakovanju božiča. Film je nastal po zgodbi dr. Seussa, enega najbolj priznanih ameriških avtorjev otroške literature. Zlovoljen, kot je, ima veseljakov seveda vrh glave. A prav nihče, niti njegov kuža, ne ve, zakaj je Grinch pravzaprav tako čemeren. Nekega dne se v Grinchevi glavi porodi ideja, da bo božiču enkrat za vselej naredil konec.',
              director: 'Ron Howard',
              cast: ['Jim Carrey', 'Taylor Momsen', 'Kelley'],
            },
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+1 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(2, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+2 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+2 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+2 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+2 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+2 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+2 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+2 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+2 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(3, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+3 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+3 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+3 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+3 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+3 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(4, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+4 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+4 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+4 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+4 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+4 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+4 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+4 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+4 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(5, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+5 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+5 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+5 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+5 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+5 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+5 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+5 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+5 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(6, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+6 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+6 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+6 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+6 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+6 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+6 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+6 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+6 Duhovni utrip: Vrata upanja',
          },
        ],
      },
      {
        date: moment().add(7, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1005, // or string syntax '10:05'
            tags: ['documentary', 'HD'], // must match show classification enum - case sensitive //TODO
            title: '+7 Dober dan: iz mariborskega studia',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1015,
            tags: ['info', 'najbolj gledani'],
            title: '+7 Umetni raj: 14. Animateka',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1025,
            tags: ['movies', 'HD'],
            title: '+7 Skrivnostni Kjoto',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1030,
            tags: ['info', 'HD'],
            title: '+7 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1040,
            tags: ['info', 'HD'],
            title: '+7 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1055,
            tags: ['info'],
            title: '+7 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1110,
            tags: [],
            title: '+7 Intervju: Dejan Valentinčič',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            airTime: 1150,
            tags: [],
            title: '+7 Duhovni utrip: Vrata upanja',
          },
        ],
      },
    ],
  },
  {
    id: 'hbo',
    name: 'HBO',
    logo: channelIcon,
    packagetags: ['HBO'],
    schedule: [
      {
        date: moment().subtract(3, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 0,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 320,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 420,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 425,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 500,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 600,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 608,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 700,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 705,
            title: '-3 Mucika: Rožica',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 720,
            title: '-3 Niko: Mesečnik Joži',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 725,
            title: '-3 Pujsa Pepa: Mehurčki',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 730,
            title: '-3 Ezopovo gledališče: Spomin na prvi dan - Zvesti orel',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 740,
            title: '-3 Bacek Jon: Krtine',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 745,
            title: '-3 Sporočilo v steklenici: Obisk',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 800,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 815,
            title: '-3 Paliativna oskrba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 925,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1000,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1100,
            title: '-3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1120,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1130,
            title: '-3 TV-izložba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1150,
            title: '-3 Divjina v srcu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['documentary'],
            airTime: 1240,
            title: '-3 Utrujeno Sredozemlje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1335,
            title: '-3 Lili in Čarni zaliv: Blatni dol v Čarnem zalivu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1345,
            title: '-3 Knjiga o džungli: Faova nesramna ukana',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1355,
            title: '-3 Firbcologi: O kofeinu, ne-spanju in mogočnih levih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1420,
            title: '-3 Fina gospa',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1500,
            title: '-3 Poročila ob petih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1520,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1525,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1530,
            title: '-3 Koda',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1605,
            title: '-3 A veš, koliko te imam rad: Odleti domov',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1615,
            title: '-3 Pujsa Pepa: Dedijev vlakec',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1625,
            title: '-3 Vem!',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1650,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1657,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1725,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1745,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1755,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1800,
            title: '-3 Zadnji tango v Halifaxu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 1905,
            title: '-3 Slepo plezanje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2000,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2005,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2035,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2045,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2055,
            title: '-3 Spomini: Zora Konjajev',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2230,
            title: '-3 Dnevnik Slovencev v Italiji',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2255,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2325,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2340,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2345,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2350,
            title: '-3 Napovedujemo',
          },
        ],
      },
      {
        date: moment().subtract(2, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 0,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 320,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 420,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 425,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 500,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 600,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 608,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 700,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 705,
            title: '-3 Mucika: Rožica',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 720,
            title: '-3 Niko: Mesečnik Joži',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 725,
            title: '-3 Pujsa Pepa: Mehurčki',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 730,
            title: '-3 Ezopovo gledališče: Spomin na prvi dan - Zvesti orel',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 740,
            title: '-3 Bacek Jon: Krtine',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 745,
            title: '-3 Sporočilo v steklenici: Obisk',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 800,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 815,
            title: '-3 Paliativna oskrba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 925,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1000,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1100,
            title: '-3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1120,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1130,
            title: '-3 TV-izložba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1150,
            title: '-3 Divjina v srcu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['documentary'],
            airTime: 1240,
            title: '-3 Utrujeno Sredozemlje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1335,
            title: '-3 Lili in Čarni zaliv: Blatni dol v Čarnem zalivu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1345,
            title: '-3 Knjiga o džungli: Faova nesramna ukana',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1355,
            title: '-3 Firbcologi: O kofeinu, ne-spanju in mogočnih levih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1420,
            title: '-3 Fina gospa',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1500,
            title: '-3 Poročila ob petih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1520,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1525,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1530,
            title: '-3 Koda',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1605,
            title: '-3 A veš, koliko te imam rad: Odleti domov',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1615,
            title: '-3 Pujsa Pepa: Dedijev vlakec',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1625,
            title: '-3 Vem!',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1650,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1657,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1725,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1745,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1755,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1800,
            title: '-3 Zadnji tango v Halifaxu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 1905,
            title: '-3 Slepo plezanje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2000,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2005,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2035,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2045,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2055,
            title: '-3 Spomini: Zora Konjajev',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2230,
            title: '-3 Dnevnik Slovencev v Italiji',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2255,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2325,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2340,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2345,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2350,
            title: '-3 Napovedujemo',
          },
        ],
      },
      {
        date: moment().subtract(1, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 0,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 320,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 420,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 425,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 500,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 600,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 608,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 700,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 705,
            title: '-3 Mucika: Rožica',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 720,
            title: '-3 Niko: Mesečnik Joži',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 725,
            title: '-3 Pujsa Pepa: Mehurčki',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 730,
            title: '-3 Ezopovo gledališče: Spomin na prvi dan - Zvesti orel',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 740,
            title: '-3 Bacek Jon: Krtine',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 745,
            title: '-3 Sporočilo v steklenici: Obisk',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 800,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 815,
            title: '-3 Paliativna oskrba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 925,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1000,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1100,
            title: '-3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1120,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1130,
            title: '-3 TV-izložba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1150,
            title: '-3 Divjina v srcu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['documentary'],
            airTime: 1240,
            title: '-3 Utrujeno Sredozemlje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1335,
            title: '-3 Lili in Čarni zaliv: Blatni dol v Čarnem zalivu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1345,
            title: '-3 Knjiga o džungli: Faova nesramna ukana',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1355,
            title: '-3 Firbcologi: O kofeinu, ne-spanju in mogočnih levih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1420,
            title: '-3 Fina gospa',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1500,
            title: '-3 Poročila ob petih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1520,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1525,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1530,
            title: '-3 Koda',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1605,
            title: '-3 A veš, koliko te imam rad: Odleti domov',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1615,
            title: '-3 Pujsa Pepa: Dedijev vlakec',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1625,
            title: '-3 Vem!',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1650,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1657,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1725,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1745,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1755,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1800,
            title: '-3 Zadnji tango v Halifaxu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 1905,
            title: '-3 Slepo plezanje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2000,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2005,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2035,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2045,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2055,
            title: '-3 Spomini: Zora Konjajev',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2230,
            title: '-3 Dnevnik Slovencev v Italiji',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2255,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2325,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2340,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2345,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2350,
            title: '-3 Napovedujemo',
          },
        ],
      },
      {
        date: moment().format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 0,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 320,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 420,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 425,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 500,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 600,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 608,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 700,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 705,
            title: '-3 Mucika: Rožica',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 720,
            title: '-3 Niko: Mesečnik Joži',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 725,
            title: '-3 Pujsa Pepa: Mehurčki',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 730,
            title: '-3 Ezopovo gledališče: Spomin na prvi dan - Zvesti orel',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 740,
            title: '-3 Bacek Jon: Krtine',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 745,
            title: '-3 Sporočilo v steklenici: Obisk',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 800,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 815,
            title: '-3 Paliativna oskrba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 925,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1000,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1100,
            title: '-3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1120,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1130,
            title: '-3 TV-izložba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1150,
            title: '-3 Divjina v srcu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['documentary'],
            airTime: 1240,
            title: '-3 Utrujeno Sredozemlje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1335,
            title: '-3 Lili in Čarni zaliv: Blatni dol v Čarnem zalivu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1345,
            title: '-3 Knjiga o džungli: Faova nesramna ukana',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1355,
            title: '-3 Firbcologi: O kofeinu, ne-spanju in mogočnih levih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1420,
            title: '-3 Fina gospa',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1500,
            title: '-3 Poročila ob petih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1520,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1525,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1530,
            title: '-3 Koda',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1605,
            title: '-3 A veš, koliko te imam rad: Odleti domov',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1615,
            title: '-3 Pujsa Pepa: Dedijev vlakec',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1625,
            title: '-3 Vem!',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1650,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1657,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1725,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1745,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1755,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1800,
            title: '-3 Zadnji tango v Halifaxu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 1905,
            title: '-3 Slepo plezanje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2000,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2005,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2035,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2045,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2055,
            title: '-3 Spomini: Zora Konjajev',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2230,
            title: '-3 Dnevnik Slovencev v Italiji',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2255,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2325,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2340,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2345,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2350,
            title: '-3 Napovedujemo',
          },
        ],
      },
      {
        date: moment().add(1, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 0,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 320,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 420,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 425,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 500,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 600,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 608,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 700,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 705,
            title: '-3 Mucika: Rožica',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 720,
            title: '-3 Niko: Mesečnik Joži',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 725,
            title: '-3 Pujsa Pepa: Mehurčki',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 730,
            title: '-3 Ezopovo gledališče: Spomin na prvi dan - Zvesti orel',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 740,
            title: '-3 Bacek Jon: Krtine',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 745,
            title: '-3 Sporočilo v steklenici: Obisk',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 800,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 815,
            title: '-3 Paliativna oskrba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 925,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1000,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1100,
            title: '-3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1120,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1130,
            title: '-3 TV-izložba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1150,
            title: '-3 Divjina v srcu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['documentary'],
            airTime: 1240,
            title: '-3 Utrujeno Sredozemlje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1335,
            title: '-3 Lili in Čarni zaliv: Blatni dol v Čarnem zalivu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1345,
            title: '-3 Knjiga o džungli: Faova nesramna ukana',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1355,
            title: '-3 Firbcologi: O kofeinu, ne-spanju in mogočnih levih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1420,
            title: '-3 Fina gospa',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1500,
            title: '-3 Poročila ob petih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1520,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1525,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1530,
            title: '-3 Koda',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1605,
            title: '-3 A veš, koliko te imam rad: Odleti domov',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1615,
            title: '-3 Pujsa Pepa: Dedijev vlakec',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1625,
            title: '-3 Vem!',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1650,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1657,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1725,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1745,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1755,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1800,
            title: '-3 Zadnji tango v Halifaxu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 1905,
            title: '-3 Slepo plezanje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2000,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2005,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2035,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2045,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2055,
            title: '-3 Spomini: Zora Konjajev',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2230,
            title: '-3 Dnevnik Slovencev v Italiji',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2255,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2325,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2340,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2345,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2350,
            title: '-3 Napovedujemo',
          },
        ],
      },
      {
        date: moment().add(2, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 0,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 320,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 420,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 425,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 500,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 600,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 608,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 700,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 705,
            title: '-3 Mucika: Rožica',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 720,
            title: '-3 Niko: Mesečnik Joži',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 725,
            title: '-3 Pujsa Pepa: Mehurčki',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 730,
            title: '-3 Ezopovo gledališče: Spomin na prvi dan - Zvesti orel',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 740,
            title: '-3 Bacek Jon: Krtine',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 745,
            title: '-3 Sporočilo v steklenici: Obisk',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 800,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 815,
            title: '-3 Paliativna oskrba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 925,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1000,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1100,
            title: '-3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1120,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1130,
            title: '-3 TV-izložba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1150,
            title: '-3 Divjina v srcu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['documentary'],
            airTime: 1240,
            title: '-3 Utrujeno Sredozemlje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1335,
            title: '-3 Lili in Čarni zaliv: Blatni dol v Čarnem zalivu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1345,
            title: '-3 Knjiga o džungli: Faova nesramna ukana',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1355,
            title: '-3 Firbcologi: O kofeinu, ne-spanju in mogočnih levih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1420,
            title: '-3 Fina gospa',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1500,
            title: '-3 Poročila ob petih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1520,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1525,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1530,
            title: '-3 Koda',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1605,
            title: '-3 A veš, koliko te imam rad: Odleti domov',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1615,
            title: '-3 Pujsa Pepa: Dedijev vlakec',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1625,
            title: '-3 Vem!',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1650,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1657,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1725,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1745,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1755,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1800,
            title: '-3 Zadnji tango v Halifaxu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 1905,
            title: '-3 Slepo plezanje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2000,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2005,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2035,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2045,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2055,
            title: '-3 Spomini: Zora Konjajev',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2230,
            title: '-3 Dnevnik Slovencev v Italiji',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2255,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2325,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2340,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2345,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2350,
            title: '-3 Napovedujemo',
          },
        ],
      },
      {
        date: moment().add(3, 'days').format('DD.MM.YYYY'),
        shows: [
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 0,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 320,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 420,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 425,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 500,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 600,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 608,
            title: '-3 Dobro jutro',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 700,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 705,
            title: '-3 Mucika: Rožica',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 720,
            title: '-3 Niko: Mesečnik Joži',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 725,
            title: '-3 Pujsa Pepa: Mehurčki',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 730,
            title: '-3 Ezopovo gledališče: Spomin na prvi dan - Zvesti orel',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 740,
            title: '-3 Bacek Jon: Krtine',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 745,
            title: '-3 Sporočilo v steklenici: Obisk',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 800,
            title: '-3 Poročila',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 815,
            title: '-3 Paliativna oskrba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 925,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1000,
            title: '-3 Kuharija na kubik: Dunajski zrezek in Sacher torta',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1100,
            title: '-3 Prvi dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1120,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1130,
            title: '-3 TV-izložba',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1150,
            title: '-3 Divjina v srcu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['documentary'],
            airTime: 1240,
            title: '-3 Utrujeno Sredozemlje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1335,
            title: '-3 Lili in Čarni zaliv: Blatni dol v Čarnem zalivu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1345,
            title: '-3 Knjiga o džungli: Faova nesramna ukana',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1355,
            title: '-3 Firbcologi: O kofeinu, ne-spanju in mogočnih levih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1420,
            title: '-3 Fina gospa',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1500,
            title: '-3 Poročila ob petih',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1520,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1525,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1530,
            title: '-3 Koda',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1605,
            title: '-3 A veš, koliko te imam rad: Odleti domov',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['cartoon'],
            airTime: 1615,
            title: '-3 Pujsa Pepa: Dedijev vlakec',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1625,
            title: '-3 Vem!',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1650,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1657,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1725,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 1745,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1755,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 1800,
            title: '-3 Zadnji tango v Halifaxu',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['movie'],
            airTime: 1905,
            title: '-3 Slepo plezanje',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2000,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2005,
            title: '-3 Odmevi',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2035,
            title: '-3 Kultura',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2045,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2055,
            title: '-3 Spomini: Zora Konjajev',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2230,
            title: '-3 Dnevnik Slovencev v Italiji',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2255,
            title: '-3 Dnevnik',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2325,
            title: '-3 Slovenska kronika',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['news'],
            airTime: 2340,
            title: '-3 Šport',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2345,
            title: '-3 Vreme',
          },
          {
            id: uuid(),
            fuzzyMatch: false,
            tags: ['show'],
            airTime: 2350,
            title: '-3 Napovedujemo',
          },
        ],
      },
    ],
  },
];

export default epgData;
